import {
  FETCH_ADMIN_ALERT_REQUEST,
  FETCH_ADMIN_ALERT_SUCCESS,
  FETCH_ADMIN_ALERT_FAILURE,
  SAVE_ADMIN_ALERT_REQUEST,
  SAVE_ADMIN_ALERT_SUCCESS,
  SAVE_ADMIN_ALERT_FAILURE,
  DELETE_ADMIN_ALERT_REQUEST,
  DELETE_ADMIN_ALERT_SUCCESS,
  DELETE_ADMIN_ALERT_FAILURE,
} from '../../../../Constants/actionTypes';
import {
  fetchAlertMessage,
  updateAdminAlertMessageApi,
  deleteAdminAlertMessageApi,
} from '../../../../Constants/apiService';

const getNetworkErrorMessage = (error, fallback) => (
  error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
    ? fallback
    : error?.message || fallback
);

export const fetchAdminAlertAct = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_ADMIN_ALERT_REQUEST });

  const accessToken = getState()?.auth?.accessToken;

  try {
    const response = await fetchAlertMessage(accessToken);
    const message = response?.message ?? null;
    dispatch({ type: FETCH_ADMIN_ALERT_SUCCESS, payload: message });
    return message;
  } catch (error) {
    const errorMessage = getNetworkErrorMessage(
      error,
      'Unable to load the current alert. Please try again.'
    );
    dispatch({ type: FETCH_ADMIN_ALERT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const saveAdminAlertAct = (message) => async (dispatch, getState) => {
  dispatch({ type: SAVE_ADMIN_ALERT_REQUEST });

  const accessToken = getState()?.auth?.accessToken;
  const trimmedMessage = String(message).trim();

  try {
    await updateAdminAlertMessageApi(trimmedMessage, accessToken);
    dispatch({ type: SAVE_ADMIN_ALERT_SUCCESS, payload: trimmedMessage });
    return trimmedMessage;
  } catch (error) {
    const errorMessage = getNetworkErrorMessage(
      error,
      'Unable to save the alert. Please try again.'
    );
    dispatch({ type: SAVE_ADMIN_ALERT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const deleteAdminAlertAct = () => async (dispatch, getState) => {
  dispatch({ type: DELETE_ADMIN_ALERT_REQUEST });

  const accessToken = getState()?.auth?.accessToken;

  try {
    const result = await deleteAdminAlertMessageApi(accessToken);
    dispatch({ type: DELETE_ADMIN_ALERT_SUCCESS });
    return result;
  } catch (error) {
    const errorMessage = getNetworkErrorMessage(
      error,
      'Unable to delete the alert. Please try again.'
    );
    dispatch({ type: DELETE_ADMIN_ALERT_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};
